/**
 * Iconos SVG compactos por categoría de vehículo (relleno + trazo, marca Servave).
 */
export type VehicleCategoryId = 'bike' | 'ebike' | 'light' | 'ice' | 'ev' | 'heavy' | 'equipment';

export function vehicleCategoryIconSvg(id: VehicleCategoryId): string {
  const common =
    'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true" focusable="false"';

  switch (id) {
    case 'bike':
      return `<svg ${common}>
  <circle cx="18" cy="44" r="9" stroke="currentColor" stroke-width="2.5"/>
  <circle cx="46" cy="44" r="9" stroke="currentColor" stroke-width="2.5"/>
  <path d="M18 44 L30 22 L38 22 L46 44 M30 22 L24 14 L34 14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    case 'ebike':
      return `<svg ${common}>
  <circle cx="17" cy="42" r="8" stroke="currentColor" stroke-width="2.3"/>
  <circle cx="47" cy="42" r="8" stroke="currentColor" stroke-width="2.3"/>
  <path d="M17 42 L29 22 L39 22 L47 42 M29 22 L23 14 H33" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M38 12 L44 8 L44 14 L38 14 Z" fill="currentColor" opacity="0.85"/>
  <path d="M42 10v6" stroke="#fff" stroke-width="1.2" stroke-linecap="round"/>
</svg>`;
    case 'light':
      return `<svg ${common}>
  <ellipse cx="22" cy="46" rx="7" ry="7" stroke="currentColor" stroke-width="2.2"/>
  <ellipse cx="48" cy="46" rx="9" ry="9" stroke="currentColor" stroke-width="2.2"/>
  <path d="M15 46 H8 L14 28 H38 L44 38 H54 L52 46" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M26 28 L32 18 H46 L42 28" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    case 'ice':
      return `<svg ${common}>
  <path d="M32 12 L38 22 L32 32 L26 22 Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/>
  <path d="M32 32 V52 M22 40 H42" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
  <ellipse cx="32" cy="52" rx="14" ry="5" stroke="currentColor" stroke-width="2"/>
</svg>`;
    case 'ev':
      return `<svg ${common}>
  <rect x="14" y="26" width="36" height="22" rx="4" stroke="currentColor" stroke-width="2.2"/>
  <path d="M50 34 H56 V40 H50" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M22 34 H38 M22 40 H34" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <circle cx="26" cy="52" r="5" stroke="currentColor" stroke-width="2"/>
  <circle cx="42" cy="52" r="5" stroke="currentColor" stroke-width="2"/>
  <path d="M32 18 L32 26 M26 20 H38" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
</svg>`;
    case 'heavy':
      return `<svg ${common}>
  <circle cx="18" cy="46" r="6" stroke="currentColor" stroke-width="2.2"/>
  <circle cx="46" cy="46" r="7" stroke="currentColor" stroke-width="2.2"/>
  <path d="M12 46 H16 L20 30 H42 L42 46 H52" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="20" y="20" width="22" height="10" rx="2" stroke="currentColor" stroke-width="2.2"/>
  <path d="M42 30 H48 L52 38 V46" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    case 'equipment':
      return `<svg ${common}>
  <circle cx="32" cy="20" r="8" stroke="currentColor" stroke-width="2.2"/>
  <path d="M32 12 V8 M32 32 V28 M24 20 H20 M44 20 H40 M26.3 13.7 L23.5 10.9 M37.7 26.3 L40.5 29.1 M37.7 13.7 L40.5 10.9 M26.3 26.3 L23.5 29.1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M18 44 L28 34 L36 42 L46 30" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M46 30 L52 24 V34 H46" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 48 H50" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
</svg>`;
    default: {
      const _x: never = id;
      return _x;
    }
  }
}
